import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=9798bb92&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=9798bb92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9798bb92",
  null
  
)

export default component.exports